"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStateWithCallback;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
function useStateWithCallback(initialState, callback) {
  var _React$useState = _react.default.useState(initialState),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var didMount = _react.default.useRef(false);
  var callbackRef = _react.default.useRef(null);
  _react.default.useEffect(function () {
    if (callbackRef.current) {
      callbackRef.current(state);
      callbackRef.current = null;
    }
  }, [state]);
  _react.default.useEffect(function () {
    if (typeof callback !== 'function' || typeof callbackRef.current === 'function') return;
    if (didMount.current) {
      callback(state);
    } else {
      didMount.current = true;
    }
  }, [state, callback]);
  var setValueWithCallback = _react.default.useCallback(function (newValue, cb) {
    if (typeof cb === 'function') callbackRef.current = cb;
    return setState(newValue);
  }, []);
  return [state, setValueWithCallback];
}